module.exports = __webpack_public_path__ + "assets/img/00112.1f802085.png";